import ApiService from '@/utils/api.service'

import { SEARCH } from '../actions/search'

const state = {
  result: []
}

const actions = {
  [SEARCH]: ({ commit}, {keyword, role}) => {
    return ApiService.post(`/searches/`, { keyword: keyword, role: role })
      .then(resp => {
        commit(SEARCH, resp.data)
      })
  }
}

const mutations = {
  [SEARCH]: (state, item) => {
    state.result = item
  }

}

export default {
  state,
  actions,
  mutations
}
